import moment from "moment";
/**
 * 공통으로 쓰이는 검증 함수 라이브러리
 * email : email@email.xx
 * password : 대소문자와 숫자를 포함하여 최소 8자 이상 50자 이하
 * npi : luhn 알고리즘으로 생성된 10자리 숫자
 * name : 모든 글자, 2자 이상 50자 이하
 * blankPattern : 모든 공백 제거를 위한 패턴
 * numberPattern : 숫자를 제외한 나머지
 * numberAndEngAndBlankPatter : 숫자, 영어, 공백, '-', '/', '.' , ',' 을 제외한 나머지
 * zipCode : 세계 공통(?) 검사 목적으로 알파벳 대소문자, 숫자, 사이에 대시와 공백 허용, 0자 이상 10글자 이하로 포괄적으로 함
 * address : 영어, 숫자, 공백 , 1글자 이상 200글자 이하 허용
 * cvc : 숫자 3이상 4이하 글자
 */

const regExp = {
    email: /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z]){1,40}@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/,
    password: /^(?=.*[a-z]{1,50})(?=.*[A-Z]{1,50})^(?=.*\d{1,50}).{8,50}$/,
    npi: /\d{10}/,
    name: /^.{1,50}$/,
    blankPattern: / /gi,
    numberPattern: /[^0-9]/gi,
    numberAndEngAndBlankPatter: /[^-/,.a-zA-Z0-9 ]/gi,
    zipCode: /^[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]$/,
    address: /[-/,.a-zA-Z0-9 ]{1,200}/,
    cvc: /^\d{3,4}$/,
    cards: [{
        type: 'Visa',
        pattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
    }, {
        type: 'Mastercard',
        pattern: /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/,
    }, {
        type: 'Discover',
        pattern: /^(?:65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10}))$/,
    },{
        type: 'JCB',
        pattern: /^(?:2131|1800|35\d{3})\d{11}$/,
    },{
        type: 'American Express',
        pattern: /^(34|37)[0-9]{14}$/,
    }]
}
const easyPW = [
    '12345',
    '123456',
    '1234567',
    '12345678',
    '123456789',
    '111111',
    '666666',
    '123123',
    '654321',
    'password',
    'sunshine',
    'qwer',
    'qwerty',
    'iloveyou',
    'princess',
    'admin',
    'welcome',
    'abc123',
    'football',
    'monkey',
    '!@#$%^&amp;*',
    'charlie',
    'aa123456',
    'donald',
    'password1',
    'qwerty123',
];
const easyPattern = [
    "0123456789",
    "abcdefghijklmnopqrstuvwxyz",
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "qwertyuiop",
    "QWERTYUIOP",
    "asdfghjkl",
    "ASDFGHJKL",
    "zxcvbnm",
    "ZXCVBNM",
];
const including = {
    pattern1: /[0-9]/,
    pattern2: /[a-z]/,
    pattern3: /[A-Z]/,
    pattern4: /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/,
}

const notIncluding = {
    pattern1: /^[a-zA-Z0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]*$/,
}

function checkEasyPW(str) {
    return true;

    /**
     * 임시 제거 (비밀번호 규칙)
     */
    // let check = true;
    // easyPW.some((item) => {
    //     check = !str.includes(item);
    //     return !check;
    // })
    //
    // return check;
}

function checkBanList(str, banList=[]) {
    return true;

    /**
     * 임시 제거 (비밀번호 규칙)
     */
    // let check = true;
    //
    // banList.some((item) => {
    //     check = !str.includes(item);
    //     return !check;
    // })
    //
    // return check;
}

function checkPattern(str, max = 4) {
    return true;

    /**
     * 임시 제거 (비밀번호 규칙)
     */
    // let ptn = "";
    // easyPattern.map((item) => {
    //     const src = item;
    //     const src2 = item + item;
    //
    //     for (let i = 0; i < src.length; i++) {
    //         const x = src.substr(i, 1);
    //         const y = src2.substr(i, max);
    //         ptn += "[" + x + "]{" + max + ",}|" + y + "|";
    //     }
    // })
    //
    // ptn = new RegExp(ptn.replace(/.$/, ""));
    //
    // return !ptn.test(str);
}

function checkIncluding(str) {
    return !(!including.pattern1.test(str)
        || !including.pattern2.test(str)
        || !including.pattern3.test(str)
        || !including.pattern4.test(str)
    );
}

function checkNotIncluding(str) {
    return notIncluding.pattern1.test(str);
}

export default {

    checkEmailValidation(email) {
        return regExp.email.test(email);
    },

    checkPasswordValidation(password, _list = []) {
        let banList = [];
        try {
            _list.map((item) => {
                banList.push(...item.split(/[\s@.]/));
            });
        } catch (e) {
            banList = [];
        }

        const {
            checkList = [
                password.length >= 8 ? 64 : 0,
                password.length <= 50 ? 32 : 0,
                checkEasyPW(password) ? 16 : 0,
                checkBanList(password, banList) ? 8 : 0,
                checkPattern(password) ? 4 : 0,
                checkIncluding(password) ? 2 : 0,
                checkNotIncluding(password) ? 1 : 0,
            ],
            msgList = [
                '8자리 이하',
                '50자리 초과',
                '금지된 암호 패턴(쉬운단어)',
                '이름 / 이메일에 포함된 문자(혹은 미입력)',
                '금지된 암호 패턴(반복패턴)',
                '대문자/소문자/특수문자/숫자 중 빠진 형태 있음',
                '대문자/소문자/특수문자/숫자를 제외한 문자 포함',
            ],
        } = this;
        const checkSum = checkList.reduce((sum, value) => {
            return sum + value;
        }, 0).toString(2).padStart(7, '0');
        const msg = msgList[checkSum.indexOf('0')] || '';

        return {
            result: parseInt(checkSum, 2) === 127,
            msg: msg
        };
    },

    checkNipValidation(value) {
        let result = false;
        if (regExp.npi.test(value)) {
            // step 1 : 마지막 자리 숫자는 검증 숫자, 검증 숫자를 제외한 9자리의 수를 왼쪽부터 홀수 번째 수를 두배로 늘린다.
            const digitArr = value.split('').map(str => (str * 1));
            const verificationNum = digitArr.pop() * 1;
            let resultArr = [];
            digitArr.forEach((digit, index) => {
                ((index + 1) % 2 === 0) ? resultArr.push(digit) : resultArr.push(digit * 2)
            });

            // step 2 : 각 자리의 숫자를 더한 후 24를 더한다. 단, 10을 넘어가는 숫자의 경우 각 자릿수를 더한다. ex) 10 = 1 + 0
            let sum = resultArr.reduce((a, b) => {
                if (b >= 10) b = String(b).split('').reduce((c, d) => (c * 1 + d * 1))
                return a + b;
            }) + 24;

            // step 3 : 합산한 값(sum)의 0으로 끝나는 다음으로 높은 숫자(bigNumEndingZero)에서 합산한 값을 뺐을 때 검증 숫자와 같다면 유효한 NPI 이다.
            // 단, 합산한 값(sum)이 0으로 끝나면서, 검증 숫자가 0이라면 유효한 NPI 이다.
            if (sum % 10 === 0) {
                result = (verificationNum === 0);
            } else {
                const bigNumEndingZero = (parseInt(sum / 10) + 1) * 10;
                result = (bigNumEndingZero - sum) === verificationNum;
            }
        }
        return result;
    },

    checkNameValidation(value) {
        return regExp.name.test(value);
    },

    checkZipCodeValidation(value) {
        return regExp.zipCode.test(value);
    },

    checkAddressValidation(value) {
        return regExp.address.test(value);
    },

    checkCardNumValidation(value) {
        const result = regExp.cards.filter((item) => {
            return item.pattern.test(value);
        });

        return result.length ? result[0].type : '';
    },

    checkCvcValidation(value) {
        return regExp.cvc.test(value);
    },

    checkExpiration(value) {
        const month = `${value[0]}${value[1]}`;
        const year = `${value[2]}${value[3]}`;
        const thisYear = moment().format('YY');

        return (1 <= Number(month)) && (Number(month) <= 12) && (Number(year) >= Number(thisYear))
    },
    removeBlank(value) {
        return value.replace(regExp.blankPattern, '')
    },
    removeWithoutNum(value) {
        return value?.replace(regExp.numberPattern, '')
    },
    removeWithoutNumAndEngAndBlank(value) {
        return value?.replace(regExp.numberAndEngAndBlankPatter, '');
    }
}